export default ({activities}) => {
	const {decode} = cdm_blocks.fn;
	const {Fragment} = React;
    return (
        <a href={ activities.link } class="activities toAnimate animate__fadeIn">
            { activities.featured_image_url ? ( 
                <figure>
                    <img src={activities.featured_image_url} />
					{ activities.type_name ? (
						<div class="cat" style={{backgroundColor: activities.color_cat}}>
							<span>{ activities.type_name }</span>
						</div>
					):(
						<div class="cat">
							<span>{ wp.i18n.__( "For everybody","theme-client" ) }</span>
						</div>
					)
					}
                </figure>
            ):(
				<figure>
                    <img src={blockData.assetsUrlImgGutenberg+"/../urbenblu-placeholder.jpg"} />
					{ activities.type_name ? (
						<div class="cat">
							<span>{ activities.type_name }</span>
						</div>
					):(
						<div class="cat">
							<span>{ wp.i18n.__( "For everybody","theme-client" ) }</span>
						</div>
					)
					}
                </figure>
			)}

			<div class="background-gradient"></div>
			
			<div class="r-content">
				<div class="horaire">
					{activities.acf.horaire.map((data)=>
						<Fragment>
							{ data.date_heure &&
								<span class="date">{ data.date_heure }</span>
							}

							{ data.description &&
								<span class="desc">{ data.description }</span>
							}
						</Fragment>
					)}
				</div>

				{ activities.title.rendered && 
					<p class="title">{activities.title.rendered}</p>
				}

				<div class="excerpt"
					dangerouslySetInnerHTML={{__html: activities.excerpt.rendered}}
				/>

				<span class="link">{ wp.i18n.__( "Learn more","theme-client" ) }</span>
				
			</div>
		</a>
    )
}

// <?php if(count($terms)): ?>
// 					
// 				<?php endif; ?>